import {
  PERMISSION_CANTILEVER_HEALTH_PLAN_EDITOR,
  PERMISSION_CANTILEVER_HEALTH_PLAN_VIEWER,
  PERMISSION_GECKO_INTERNAL_MEMBER,
  PermissionsGate,
  PermissionsGateProps,
} from 'features/auth'
import React, { FC } from 'react'

export const AssetHealthFeaturePermissionGate: FC<
  Omit<PermissionsGateProps, 'requires' | 'operation'>
> = ({ children, ...props }) => {
  return (
    <PermissionsGate
      {...props}
      requires={[
        PERMISSION_CANTILEVER_HEALTH_PLAN_VIEWER,
        PERMISSION_CANTILEVER_HEALTH_PLAN_EDITOR,
        PERMISSION_GECKO_INTERNAL_MEMBER,
      ]}>
      {children}
    </PermissionsGate>
  )
}
